import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HostComponent } from 'zr-dynamic-form/dynamic-form-common';

import { ListComponent } from './partial/list/list.component';
import { AddComponent } from './partial/add/add.component';
import { EditComponent } from './partial/edit/edit.component';
import { DetailComponent } from './partial/detail/detail.component';

const children = [
  { path: '', component: ListComponent, data: { title: 'è¡¨ååè¡¨' } },
  { path: 'add', component: AddComponent, data: { title: 'æ·»å ' } },
  { path: 'edit/:id', component: EditComponent, data: { title: 'ç¼è¾' } },
  { path: 'detail/:id', component: DetailComponent, data: { title: 'æ¥ç' } }
];

const routes: Routes = [
  {
    path: 'dynamic-form-run/:formCode',
    component: HostComponent,
    data: { title: 'è¡¨å' },
    children: children
  },
  {
    path: 'dynamic-form-run/:formCode/:labelCode',
    component: HostComponent,
    data: { title: 'è¡¨å' },
    children: children
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class DynamicFormDynamicPageRoutingModule {}
